import React from 'react'
import { motion } from "framer-motion"
import {SiGooglemaps} from 'react-icons/si'
import {FiPhoneCall} from 'react-icons/fi'

const Info = ({isEng, showInfo, info }) => {
    
    const information =  info[0]
  
    let phone = information?.telephone
    
    let googleAddress = 'https://www.google.com/maps/place/%D0%9C%D0%B0%D0%BB%D0%BA%D0%B8%D1%8F+%D0%AF%D0%B2%D0%BE%D1%80+-+%D1%81.%D0%9F%D1%8A%D1%80%D0%B2%D0%B5%D0%BD%D0%B5%D1%86/@42.0673517,24.6543576,17z/data=!4m15!1m8!3m7!1s0x14acc45b10471dbf:0xe83f3b667c416df4!2z0JzQsNC70LrQuNGPINCv0LLQvtGAIC0g0YEu0J_RitGA0LLQtdC90LXRhg!8m2!3d42.0673477!4d24.6569325!10e1!16s%2Fg%2F11byl7t71v!3m5!1s0x14acc45b10471dbf:0xe83f3b667c416df4!8m2!3d42.0673477!4d24.6569325!16s%2Fg%2F11byl7t71v?entry=ttu'
   
    return (
        
        <motion.div
            initial={false}
            animate={{height: showInfo ? 250 : 0}}
            
            className={showInfo ? `flex flex-row   bg-beigeOne items-center text-2xl text-greenTwo` : 'invisible '}>
            {information && 
            <>
            <div className='flex flex-col text-center w-9/12 ml-2'>
                <h1>{!isEng ? "Работно време:" : "Working hours:"}</h1>
                {information?.workingHours}                
                <p>{!isEng ? "Почивен ден:" : "Rest day:"}</p>
                {!isEng ? information?.restDay : information?.restDay_eng}
            </div>
            <div className='flex flex-col text-center items-center  w-5/12 mr-2'>
                
                <a className='flex flex-col' href={`tel:+${phone}`}>
                <div className='flex flex-row justify-center'>
                <h1>{!isEng ? "Тел. :" : "Phone :"}</h1> <motion.div
                    
                    animate={{scale:1.3}}
                    transition={{
                        repeat:Infinity,
                        repeatType:'reverse',
                        duration:1
                    }}
                ><FiPhoneCall className='ml-2 text-greenOne' /></motion.div>
                </div>
                <h1>+{information?.telephone} </h1>
                
                </a>               
                
                <a href={googleAddress}> 
                <div className='w-2/3 flex flex-row justify-center m-auto mt-2'>
                
                    <h1>{!isEng ? "Адрес:" : "Address:"}</h1>
                    <motion.div 
                    animate={{scale:1.3}}
                    
                    transition={{
                        repeat:Infinity,
                        repeatType:'reverse',
                        duration:1
                    }}>
                    <SiGooglemaps className='ml-2 text-greenOne' size={30}></SiGooglemaps>
                    </motion.div>
                    </div>
                   
                <h1>{!isEng ? information.address : information.address_eng}</h1>
                </a>
              
            </div>
            </> }
        </motion.div>
    )
}

export default Info